module.exports = __webpack_public_path__ + "linkedin_squircle_charcoal.svg?fcd596d6d2e7415b540d8227c28c126d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social/linkedin_squircle_charcoal.svg
// module id = 132
// module chunks = 0